<template>
    <div class="background" v-if="message.isShow" >
        <div id="modalMessage"  class="fixed-top">
            <div ref="cardHeaderObject" class="card">
                <div class="card-header ">
                    <b v-html="message.topic"></b>
                </div>
                <div class="card-body">
                    <div v-html="message.info"></div>
                    <button @click="close" class="button button-ghost-primary mt-2">{{$t('general.okay')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
    name: "ModalMessage",
    updated() {
        if(this.message.event) {
            this.$nextTick(() => {
                this.$refs.cardHeaderObject.style.top = (this.message.getCursorPos().y - (this.$refs.cardHeaderObject.clientHeight/2) ) + "px"
            })
        }
    },
    data() {
        return {}
    },
    methods: {
        close() {
            this.$store.dispatch('app/closeModalMessage');
        }
    },
    computed: {
        ...mapGetters({
            message: 'app/getModalMessage'
        })
    }
}
</script>

<style lang="scss" scoped>
    .background {
        width: 100%;
        position: fixed;
        z-index: 300;
        margin: 0px;
        height: 100%;
        top:0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.3);
    }

    #modalMessage {
        margin-top: 50px;
    }

    .card {
        margin: auto;
//        margin-top: 40px;
        max-width: 450px;
        background-color: white;
        border-radius: var(--border-radius-default);
      padding: 2rem;
        }

    .card-header {
        padding-top: 10px;
    }

        .fixed-top {
            position: fixed;
            z-index: 100;
            top: 50%;
            left: 50%;
          transform: translate(-50%, -50%);
        }

        .card-body {
            padding: 10px;
        }
</style>